import { BusFill24Icon, TrainOutline24Icon } from "@vygruppen/spor-icon-react";
import { withErrorBoundary } from "app/ErrorBoundary/ErrorBoundaryDashboard";
import { VehicleMapBus } from "features/CenterContent/RoleContent/VehicleMap/VehicleMapBus";
import VehicleMapTrain from "features/CenterContent/RoleContent/VehicleMap/VehicleMapTrain";
import { SharedGridStyle } from "features/CenterContent/shared/MainContentGrid";
import { useState } from "react";
import {
  Flex,
  HStack,
  Tabs,
  TabsList,
  TabsTrigger,
  Text,
} from "shared/components/Spor";
import { useDropsRole } from "stores/useDropsRole";
import styled, { useTheme } from "styled-components";

export const Wrapper = styled(Flex)`
  ${SharedGridStyle}
  padding: 0;
  overflow: hidden;

  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
`;

enum VehicleMapType {
  Train,
  Bus,
}

const VehicleMap = () => {
  const theme = useTheme();
  const { isTrafikkplanlegger } = useDropsRole();

  const [vehicleMapType, setVehicleMapType] = useState(() =>
    isTrafikkplanlegger() ? VehicleMapType.Bus : VehicleMapType.Train,
  );

  const tabs = ["train", "bus"];

  return (
    <Wrapper
      position="relative"
      height="100%"
      width="100%"
      align="center"
      justify="center"
    >
      <Tabs
        variant="accent"
        position="absolute"
        zIndex="1000"
        colorScheme="base"
        left="10px"
        top="10px"
        size="lg"
        // We must use onValueChange (instead of <TabsContent/>) since putting VehicleMap inside Tabs messes up its size
        onValueChange={(e: { value: string }) =>
          setVehicleMapType(tabs.indexOf(e.value))
        }
        defaultValue={isTrafikkplanlegger() ? tabs[1] : tabs[0]}
      >
        <TabsList background={theme.colorBackgroundMain}>
          <TabsTrigger value={tabs[0]}>
            <HStack mx="36px">
              <TrainOutline24Icon />
              <Text>Tog</Text>
            </HStack>
          </TabsTrigger>
          <TabsTrigger value={tabs[1]}>
            <HStack mx="36px">
              <BusFill24Icon />
              <Text>Buss</Text>
            </HStack>
          </TabsTrigger>
        </TabsList>
      </Tabs>
      {vehicleMapType === VehicleMapType.Train && <VehicleMapTrain />}
      {vehicleMapType === VehicleMapType.Bus && <VehicleMapBus />}
    </Wrapper>
  );
};

export default withErrorBoundary(VehicleMap);
